import React, {ChangeEvent, Component, FormEvent} from 'react';
import classes from './Login.module.css'
import {login} from '../../api/Auth'

import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"
import Loader from 'react-loader-spinner'
//import {getI18n, Trans} from "react-i18next";

import AppIcon from "../../assets/img/cotentin.svg"

interface IProps {}
interface IState {
    username: string,
    password: string,
    error: object|undefined,

    isJwtTokenLoaded: boolean,
    requestInProgress: boolean
}

class Login extends Component<IProps, IState> {

    constructor(props: IProps){
        super(props)
        this.state = {
            username: "",
            password: "",
            error: undefined,

            isJwtTokenLoaded: false,
            requestInProgress: false
        }
    }

    componentDidMount(){
        console.log(process.env)
        this.handleSubmit = this.handleSubmit.bind(this);
    }


    handleSubmit = async(event: FormEvent) => {
        event.preventDefault()
        this.setState({requestInProgress: true}, async() => {
            const loginResult = await login(this.state.username, this.state.password)
            this.setState({requestInProgress: false}, async() => {
                if(!loginResult.success){
                    this.setState({ error : loginResult.error })
                }else {
                    this.setState({
                        isJwtTokenLoaded : true,
                        error: undefined
                    })
                    window.location.replace("/")
                }
            });
        })
    }

    handleUsernameChanged = (event: ChangeEvent<HTMLInputElement>) => {
        this.setState({username: event.target.value})
    }

    handlePasswordChanged = (event: ChangeEvent<HTMLInputElement>) => {
        this.setState({password: event.target.value})
    }


    render() {
        // Display in case of loading and during redirection
        const validationSection = (this.state.requestInProgress || this.state.isJwtTokenLoaded) ?
            (<div className={classes.LoginSpinnerContainer}>
                <div className={classes.LoginSpinnerContent}>
                    <Loader
                        type="Oval"
                        color="#FFFFFF"
                        height={30}
                        width={100}
                    />

                </div>
            </div>)
            :
            <input className={classes.LoginValidateButton} type={"submit"} value={"CONNEXION"}/>

        return (
            <div className={classes.LoginContainer}>
                <div style={{textAlign: "center", marginBottom: "20px", height: "80px"}}>
                    <img src={AppIcon} alt={"App icon"} style={{height: "100%"}}/>
                </div>
                {/* <h1><Trans>NUCLEOT_LOGIN</Trans></h1> */}
                <form onSubmit={this.handleSubmit} className={classes.LoginForm}>
                    <label>EMAIL</label>
                    <input type="email" onChange={this.handleUsernameChanged} required/>

                    <label>PASSWORD</label>
                    <input type="password" onChange={this.handlePasswordChanged} required/>

                    {this.state.error != null ? <p style={{color:"red"}}>{this.state.error}</p> : null}

                    {validationSection}
                </form>
                
                <label style={{textAlign: "center", marginTop: "10px"}}>L'accès à ce service est strictement réservé aux utilisateurs authentifiés et disposants d'un accès valide.</label>
                <br />
                <label style={{textAlign: "center"}}>Tous droits réservés Fastpoint {new Date(Date.now()).getFullYear()}</label>
            </div>
        );
    }
}

export default Login
